import { Label, Button } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import { FC } from 'react';
import { SortableBlockList } from '../../molecules';
import { BlockItem } from '../../atoms/SortableImageBlockItem/SortableImageBlockItem';
import { BlockType } from '../../../store/landscapeAPI/block/dto/block-type';
import styles from './OrganizationContentBlocksOrganism.module.css';
import cn from 'classnames';

interface OrganizationContentBlocksOrganismProps {
  blockItems: BlockItem[];
  setBlockItems: (items: BlockItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
  setChangeOrderEnabled: (enabled: boolean) => void;
  handleDelete: (id: string) => void;
  handleEdit: (id: string, type: BlockType) => void;
}

const OrganizationContentBlocksOrganism: FC<
  OrganizationContentBlocksOrganismProps
> = ({
  blockItems,
  setBlockItems,
  changeOrderEnabled,
  setChangeOrderEnabled,
  handleDelete,
  handleEdit,
}) => {
  const navigate = useNavigate();
  const { organizationId } = useParams();
  return (
    <div className={cn(styles.contentBlocksWrapper)}>
      <Label
        size="heading-l"
        content="These blocks will be added to the general page of a landscape"
        bold
      />

      <div className={cn(styles.buttonGroup)}>
        <Button
          variant="light"
          className={cn(styles.button)}
          onClick={() =>
            navigate(`/organizations/edit/${organizationId}/image-block/add`)
          }
        >
          Add Image Block
        </Button>
        <Button
          variant="light"
          className={cn(styles.button)}
          onClick={() =>
            navigate(`/organizations/edit/${organizationId}/text-block/add`)
          }
        >
          Add Text Block
        </Button>
      </div>
      <div className={cn(styles.changeOrder)}>
        <Button
          variant="light"
          className={cn(styles.button)}
          onClick={() => setChangeOrderEnabled(!changeOrderEnabled)}
        >
          Change Order
        </Button>
      </div>
      <div className={cn(styles.sortableBlockListWrapper)}>
        <SortableBlockList
          blockItems={blockItems}
          setBlockItems={setBlockItems}
          changeOrderEnabled={changeOrderEnabled}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />
      </div>
    </div>
  );
};

export default OrganizationContentBlocksOrganism;
